"use client";

import { toast } from "sonner";

export default function ContactForm() {
  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    const data = new FormData(form);

    const res = await fetch("https://formspree.io/f/mzzgddko", {
      method: "POST",
      body: data,
      headers: {
        Accept: "application/json",
      },
    });

    if (res.ok) {
      toast.success("Message sent successfully!");
      form.reset();
    } else {
      toast.error("Oops! Something went wrong. Please try again.");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4 color_red">
      <div>
        <label className="block color_black">Name</label>
        <input
          type="text"
          name="name"
          required
          placeholder="Your Name"
          className="w-full border border-black rounded px-4 py-2 mt-1 placeholder:text-xs placeholder:text-black"
        />
      </div>

      <div>
        <label className="block color_black">Email</label>
        <input
          type="email"
          name="email"
          required
          placeholder="you@example.com"
          className="w-full border border-black rounded px-4 py-2 mt-1 placeholder:text-xs placeholder:text-black"
        />
      </div>

      <div>
        <label className="block color_black">Message</label>
        <textarea
          name="message"
          required
          rows="4"
          placeholder="Write your message..."
          className="w-full border border-black rounded px-4 py-2 mt-1 placeholder:text-xs placeholder:text-black"
        ></textarea>
      </div>

      <button
        type="submit"
        className="bg-black text-white px-6 py-2 rounded hover:bg-gray-800"
      >
        Send Message
      </button>
    </form>
  );
}
